/**
 * Memerle — Table des matières auto (H2 du corps d'article)
 */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initArticleToc(section) {
    if (!section || section.dataset.tocInit === 'true') return;
    const body = section.querySelector('[data-article-body]');
    const nav = section.querySelector('[data-article-toc-list]');
    if (!body || !nav) return;

    const headings = body.querySelectorAll('h2');
    if (!headings.length) {
      const tocWrap = section.querySelector('[data-article-toc]');
      if (tocWrap) tocWrap.hidden = true;
      return;
    }

    section.dataset.tocInit = 'true';
    nav.innerHTML = '';

    const usedIds = new Set();
    headings.forEach((heading, index) => {
      const label = heading.textContent.trim();
      if (!label) return;

      let id = heading.id || slugify(label);
      if (!id) id = 'section-' + (index + 1);
      while (usedIds.has(id)) {
        id = id + '-' + (index + 1);
      }
      usedIds.add(id);
      heading.id = id;
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = label;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
        heading.focus({ preventScroll: true });
      });
      item.appendChild(link);
      nav.appendChild(item);
    });
  }

  function boot() {
    document.querySelectorAll('[data-memerle-article]').forEach(initArticleToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-memerle-article]');
    if (section) initArticleToc(section);
  });
})();
